import z from "zod"

export const loginSchema = z.object({
  name: z.string().trim().min(1, "Informe seu nome").max(50).refine(value => new TextEncoder().encode(value).length >= 3, "Informe seu nome"),
  phone: z.string().length(15, "Telefone inválido"),
})

export type LoginSchemaType = z.infer<typeof loginSchema>
